/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The AqaAnnotationScore model module.
 * @module model/AqaAnnotationScore
 * @version v0
 */
export default class AqaAnnotationScore {
  /**
   * Constructs a new <code>AqaAnnotationScore</code>.
   * @alias module:model/AqaAnnotationScore
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>AqaAnnotationScore</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AqaAnnotationScore} obj Optional instance to populate.
   * @return {module:model/AqaAnnotationScore} The populated <code>AqaAnnotationScore</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new AqaAnnotationScore();
      if (data.hasOwnProperty('numberOfWhiteCellsMarkedForFix'))
        obj.numberOfWhiteCellsMarkedForFix = ApiClient.convertToType(data['numberOfWhiteCellsMarkedForFix'], 'Number');
      if (data.hasOwnProperty('totalNumberOfRowsConcerned'))
        obj.totalNumberOfRowsConcerned = ApiClient.convertToType(data['totalNumberOfRowsConcerned'], 'Number');
      if (data.hasOwnProperty('numberOfRowsConcernedOtherwiseWithoutScoredReds'))
        obj.numberOfRowsConcernedOtherwiseWithoutScoredReds = ApiClient.convertToType(data['numberOfRowsConcernedOtherwiseWithoutScoredReds'], 'Number');
    }
    return obj;
  }
}

/**
 * @member {Number} numberOfWhiteCellsMarkedForFix
 */
AqaAnnotationScore.prototype.numberOfWhiteCellsMarkedForFix = undefined;

/**
 * @member {Number} totalNumberOfRowsConcerned
 */
AqaAnnotationScore.prototype.totalNumberOfRowsConcerned = undefined;

/**
 * @member {Number} numberOfRowsConcernedOtherwiseWithoutScoredReds
 */
AqaAnnotationScore.prototype.numberOfRowsConcernedOtherwiseWithoutScoredReds = undefined;

